var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    id: "call",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1.5,
    x2: 24.803,
    y1: 16,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2B2E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE4F9C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M21.5 18.7c-.5-.5-1.3-.6-1.9-.2L17.5 20c-.6.4-1.4.3-1.9-.2l-5.5-5.5c-.5-.5-.6-1.3-.2-1.9l1.5-2.2c.4-.6.3-1.4-.2-1.9L8.9 6.1c-.6-.6-1.5-.6-2.1 0L4.9 8c-1.1 1.1-1.6 2.7-1.2 4.3.6 2.4 1.8 4.5 3.5 6.2l4.1 4.1c1.7 1.7 3.9 2.9 6.2 3.5.4.1.7.1 1.1.1 1.2 0 2.3-.5 3.2-1.3l1.9-1.9c.3-.3.4-.7.4-1.1 0-.4-.2-.8-.4-1.1l-2.2-2.1zM7.5 6.8c.1-.1.2-.1.4-.1s.3 0 .4.1L10.5 9c.2.2.2.4.1.6l-1 1.4-3.1-3.1 1-1.1zm10.3 18.4c-2.2-.5-4.2-1.7-5.7-3.3L8 17.8c-1.6-1.6-2.7-3.6-3.3-5.7-.3-1.2.1-2.5.9-3.3l.2-.2 3.3 3.3c-.7 1-.5 2.3.3 3.2l5.5 5.5c.8.8 2.2 1 3.1.3l3.3 3.3-.2.2c-.8.8-2.1 1.1-3.3.8zm5.3-2.8-1.1 1-3.2-3.2 1.4-.9c.2-.1.5-.1.6.1l2.2 2.2c.1.1.1.2.1.4.1.2.1.3 0 .4z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1.5,
    x2: 24.803,
    y1: 19.045,
    y2: 19.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2B2E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE4F9C"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m22.7 18.5 1.4 1.4c.4-.4.4-1 0-1.4-.3-.4-1-.4-1.4 0z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1.5,
    x2: 24.803,
    y1: 17.523,
    y2: 17.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2B2E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE4F9C"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M27 15.7c-1.3-1.3-3.1-1.8-4.8-1.3-.3.1-.4.3-.4.6.1.3.3.4.6.4 1.4-.4 2.9 0 3.9 1s1.4 2.5 1 3.9c-.1.3.1.5.4.6h.1c.2 0 .4-.1.5-.4.4-1.7-.1-3.6-1.3-4.8z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 1.5,
    x2: 24.803,
    y1: 18.264,
    y2: 18.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2B2E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE4F9C"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M22.7 16.3c-.3.1-.4.3-.4.6.1.3.3.4.6.4.7-.2 1.4 0 1.9.5s.7 1.2.5 1.9c-.1.3.1.5.4.6h.1c.2 0 .4-.1.5-.4.3-1 0-2.1-.8-2.9-.7-.7-1.8-1-2.8-.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.c476c3cd2807b7b18fbef0b2b29992c9.svg";
export { ForwardRef as ReactComponent };